import { render, staticRenderFns } from "./AllocHandle.vue?vue&type=template&id=768a7123&scoped=true"
import script from "./AllocHandle.vue?vue&type=script&lang=js"
export * from "./AllocHandle.vue?vue&type=script&lang=js"
import style0 from "./AllocHandle.vue?vue&type=style&index=0&id=768a7123&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768a7123",
  null
  
)

export default component.exports